const initState = {
  limit: 100,
  search: "",
};

const reportReducer = (state = initState, action) => {
  switch (action.type) {
    case "UPDATE_REPORT_QUERY":
      return {
        ...state,
        limit: action.payload.limit,
        search: action.payload.search,
      };
    default:
      return state;
  }
};

export default reportReducer;
